import { KeyboardReturnRounded } from '@mui/icons-material';
import { HotKeyBox } from '../HotKeyBox';

interface ReturnHotKeyIconProps {
  isDisabled?: boolean;
  backgroundColor?: string;
}

export const ReturnHotKeyIcon = ({
  isDisabled,
  backgroundColor,
}: ReturnHotKeyIconProps) => {
  const getHotKeyBgColor = () => {
    if (backgroundColor) {
      return backgroundColor;
    }
    return isDisabled ? 'misc.hotKey.disabled' : undefined;
  };

  return (
    <HotKeyBox
      hotkeyDisplay={<KeyboardReturnRounded />}
      backgroundColor={getHotKeyBgColor()}
    />
  );
};
